import { useCallback, useEffect, useState } from 'react'
import { createPreviewSession, type PreviewSession } from '../api/client'

// usePreviewSession loads the URL to show projectId's preview in an iframe,
// and `fresh()` mints a new one (signed links expire after a few minutes).
export function usePreviewSession(projectId: string | undefined, enabled = true) {
  const [session, setSession] = useState<PreviewSession | null>(null)

  const fresh = useCallback(async (): Promise<PreviewSession | null> => {
    if (!projectId) return null
    try {
      const s = await createPreviewSession(projectId)
      setSession(s)
      return s
    } catch {
      return null
    }
  }, [projectId])

  useEffect(() => {
    if (enabled) void fresh()
  }, [enabled, fresh])

  return { url: session?.url ?? '', crossOrigin: session?.cross_origin ?? false, fresh }
}
